import { Component, Element, Method, Event, EventEmitter, h, Prop, Host } from '@stencil/core';

/**
 * Defaul modal component
 */
@Component({
  tag: 'zpr-modal',
  styleUrl: 'modal.scss'
})
export class ZprModal {
  @Element() el: HTMLElement;

  @Prop() size: 'small' | 'medium' | 'large' = 'medium';
  @Prop({ reflect: true, mutable: true }) isOpened: boolean = false;
  @Prop({ reflect: true, mutable: true }) canClose?: boolean = true;

  @Event() closed: EventEmitter;
  @Event() opened: EventEmitter;

  @Method()
  async open() {
    if (this.isOpened) return;
    this.isOpened = true;
    this.opened.emit();
  }

  @Method()
  async close(shouldEmit = true, force = false) {
    if (!force && (!this.isOpened || !this.canClose)) return;
    this.isOpened = false;
    // this allows a parent component to manage closing of the modal
    if (shouldEmit) this.closed.emit();
  }

  componentDidLoad() {
    this.el.querySelectorAll('[data-modal="close"]').forEach(el => {
      el.addEventListener('click', ev => {
        ev.preventDefault()
        this.close()
      })
    })
    this.el.addEventListener('mousedown', ev => {
      // wrapper has a stopPropagation that will prevent any clicks inside the modal reaching here
      this.close()
    })
    window.addEventListener('keydown', ev => {
      if (ev.key === 'Escape') this.close()
    })
  }

  render() {
    return <Host class={{[this.size]: true, 'open': this.isOpened}} role="dialog">
      <div class="wrapper" onMouseDown={ev => ev.stopPropagation()} onKeyDown={ev => ev.stopPropagation()}>
        { this.canClose ? <button type="button" data-modal="close"></button> : null}
        <header><slot name="header" /></header>
        <main><slot name="body" /></main>
        <footer><slot name="footer" /></footer>
      </div>
    </Host>
  }
}
